import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { updateSlider } from "../actions/componentStatus/sliders";
import Slider from "../components/Slider";
import PropTypes from "prop-types";

class SliderContainer extends PureComponent {
  componentDidMount() {
    const { updateSlider, componentValue } = this.props;

    updateSlider(componentValue);
  }

  componentDidUpdate(prevProps) {
    const { componentValue, updateSlider } = this.props;

    if (componentValue !== prevProps.componentValue) {
      updateSlider(componentValue);
    }
  }

  render() {
    const { updateSlider } = this.props;

    return (
      <Slider
        {...this.props}
        onChange={updateSlider}
        value={this.sliderValue()}
      />
    );
  }

  sliderValue() {
    const { componentValue, value } = this.props;

    if (Number.isInteger(value)) {
      return value;
    } else {
      return componentValue;
    }
  }
}

function mapStateToProps(state, ownProps) {
  const { id } = ownProps;

  return {
    value: state.componentStatus.sliders[id]
  };
}

function mapDispatchToProps(dispatch, ownProps) {
  const { id } = ownProps;

  return {
    updateSlider: e => {
      if (e.target) {
        dispatch(updateSlider(id, e.target.valueAsNumber));
      } else {
        dispatch(updateSlider(id, e));
      }
    }
  };
}

SliderContainer.propTypes = {
  id: PropTypes.string.isRequired,
  componentValue: PropTypes.number.isRequired
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SliderContainer);
